export const GET_OFFERS = "GET_OFFERS";
export const EDIT_OFFER = "EDIT_OFFER";
export const DELETE_OFFER = "DELETE_OFFER";
export const GET_OFFER_BY_ID = "GET_OFFER_BY_ID";
export const SET_OFFER_TO_NULL = "GET_OFFER_BY_ID";
export const GET_YEARS = "GET_YEARS";
export const GET_OFFER_BY_OFFERNUMBER = "GET_OFFER_BY_OFFERNUMBER";
